import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import SettingsIcon from '@mui/icons-material/MoreHoriz';
import { toast } from 'react-toastify';
import $ from 'jquery';
import { httpGet, httpPut } from '../../HttpRequestHandling/httpRequestHandler';
import { InputCheckbox } from '../FormFieldControls/InputCheckbox';
import { GeneralInfo } from './GeneralInfo'
import { CompanyRoutingSetup } from './CompanyRoutingSetup'
import { APInvoiceLandingSetup } from './APInvoiceLandingSetup'
import { EmailReminderSetup } from './EmailReminderSetup'
import { ApprovalStampConfiguration } from '../InvoiceModels/InvoiceModelSetup/ApprovalStampConfiguration';
import CloudStorageConfig from './CloudStorageConfig';
import { CompanyIdentifier } from './CompanyIdentifier'
import { LabelText } from '../FormFieldControls/LabelText';
import { isNewUi } from '../../redesign/uiMode';
import StatusTabs, { loadTab, storeTab } from '../../redesign/lists/StatusTabs';

export default class CompanyConfiguration extends React.Component {
	constructor() {
		super();

		this.dataLoaded = false;

		this.state = { company: null, isDirty: false, openResetConfirmation: false };

		this.collapseExpandHandler = this.collapseExpandHandler.bind(this);
		this.resetClickHandler = this.resetClickHandler.bind(this);
		this.resetYesClickHandler = this.resetYesClickHandler.bind(this);
		this.resetNoClickHandler = this.resetNoClickHandler.bind(this);
		this.updateClickHandler = this.updateClickHandler.bind(this);
		this.settings_clickHandler = this.settings_clickHandler.bind(this);
		this.popover_closeHandler = this.popover_closeHandler.bind(this);
		this._ddlTaxSetting_changeHandler = this._ddlTaxSetting_changeHandler.bind(this);

		this.changeHandler = this.changeHandler.bind(this);
	}

	componentDidMount() {
		this.fetchCompany();
	}

	fetchCompany() {
		var that = this;

		const userInfo = JSON.parse(localStorage.userInfo);

		this.props.inProgress(true);

		httpGet('/api/company/' + userInfo.companyCode)
			.then((response) => {
				var data = response.data;
				this.dataLoaded = true;

				that.setState({ company: data, isDirty: false });

				this.props.inProgress(false);
			}).catch((error) => {
				this.props.inProgress(false);
				toast.error('An error occurred while fetching the company record');
			});
	}

	collapseExpandHandler(event) {
		this.setState({
			[event.target.id]: event.target.value
		})
		$('.' + event.currentTarget.id).slideToggle('slow', function () {

		});
	}

	resetClickHandler(event) {
		this.setState({ openResetConfirmation: true });
	}

	resetYesClickHandler(event) {
		event.preventDefault();

		this.fetchCompany();

		toast.success('Company Reset Successfully');
		this.setState({ openResetConfirmation: false });
	}

	resetNoClickHandler(event) {
		this.setState({ openResetConfirmation: false });
	}

	updateClickHandler(event) {
		var that = this;

		this.props.inProgress(true);

		httpPut('/api/company/', this.state.company)
			.then((response) => {
				this.props.inProgress(false);
				that.setState({ isDirty: false });
				toast.success('Company updated successfully');
			}).catch((error) => {
				this.props.inProgress(false);
				toast.error(<div>Company Update Failed<br />{error.response.data}</div>);
			});
	}

	changeHandler(event, modelDefId, childListName) {
		var comp = this.state.company;

		if (arguments.length === 1) {
			comp[event.target.name] = typeof (comp[event.target.name]) === "number" ? parseInt(event.target.value, 10) : event.target.value
		}
		else {
			var childListObject = comp[childListName].find(c => c.modelDefId === modelDefId);
			var propertyName = event.target.dataset.name !== undefined ? event.target.dataset.name : event.target.name;

			childListObject[propertyName] = typeof (childListObject[propertyName]) === "number" ? parseInt(event.target.value, 10) : event.target.value;
		}

		this.setState({
			company: comp,
			isDirty: true
		})
	}

	settings_clickHandler(event) {

		this.setState({ anchorEl: event.currentTarget });
	}

	_ddlTaxSetting_changeHandler(event) {
		const comp = { ...this.state.company };
		comp[event.target.name] = event.target.value;
		this.setState({
			company: comp,
			isDirty: true
		});
	}

	popover_closeHandler(event) {
		this.setState({ anchorEl: null });
	}

	// New UI (docs/ui_redesign/14-screen-concepts.md, "Company configuration", option B): tabs for General and each
	// module, each holding that module's routing, approval levels, invoice setup and email reminder. The same
	// components, fields, handlers, Reset and Update; only their grouping changes. Every tab stays mounted.
	renderNewUi({ companyApprovalConfigurationList, companyInvoiceConfigurationList, companyRoutingFields, resetButton, updateButton, resetDialog, approvalStamp }) {
		const company = this.state.company;
		const modules = [];
		[...company.companyApprovalConfigurations, ...company.companyInvoiceConfigurations].forEach(c => {
			if (!modules.some(m => m.id === c.modelDefId)) modules.push({ id: c.modelDefId, name: c.masterDefName });
		});
		const keys = ['general', ...modules.map(m => 'm' + m.id)];
		const tab = keys.includes(this.state.apw2Tab) ? this.state.apw2Tab : loadTab('apworks.companyTab', keys, 'general');
		const setTab = key => { storeTab('apworks.companyTab', key); this.setState({ apw2Tab: key }); };
		const section = (title, sub, body) => (
			<section className="apw2-co-sec" aria-label={title}>
				<div className="apw2-co-sec-h"><h2>{title}</h2>{sub ? <span>{sub}</span> : null}</div>
				<div className="apw2-co-sec-b">{body}</div>
			</section>
		);
		const routing = id => companyApprovalConfigurationList[company.companyApprovalConfigurations.findIndex(c => c.modelDefId === id)] || null;
		const reminder = id => companyInvoiceConfigurationList[company.companyInvoiceConfigurations.findIndex(c => c.modelDefId === id)] || null;
		return (
			<div className="apw2-co">
				<h1>Company Configuration</h1>
				<div className="apw2-co-card">
					<StatusTabs label="Company configuration" controls="apw2-co-panel" value={tab} onChange={setTab}
						tabs={[{ key: 'general', label: 'General' }, ...modules.map(m => ({ key: 'm' + m.id, label: m.name }))]} />
					<div className="apw2-co-panels" id="apw2-co-panel" role="tabpanel" aria-labelledby={'apw2-stab-' + tab}>
						<div className="apw2-co-tab" hidden={tab !== 'general'}>
							{section('General info', null, <GeneralInfo company={company} changeHandler={this.changeHandler} />)}
							{section('Company identifiers', null, <CompanyIdentifier company={company} setInProgress={this.props.inProgress} />)}
							{section('Invoice routing', 'All modules', <div className="col-md-12 form-group">{companyRoutingFields}</div>)}
							{section('Invoice storage', 'All modules', <APInvoiceLandingSetup part="company" company={company} changeHandler={this.changeHandler} />)}
						</div>
						{modules.map(m => (
							<div key={m.id} className="apw2-co-tab apw2-co-module" hidden={tab !== 'm' + m.id}>
								{routing(m.id) && section('Approval routing', 'Number of levels, matching and each level\'s names', routing(m.id))}
								{section('Invoice setup', null, <APInvoiceLandingSetup part={m.id} company={company} changeHandler={this.changeHandler} />)}
								{reminder(m.id) && section('Email reminder', null, reminder(m.id))}
							</div>
						))}
					</div>
					<div className="apw2-savebar" role="region" aria-label="Save changes">
						{this.state.isDirty ? <span className="apw2-savebar-note"><b>Unsaved changes</b></span> : <span className="apw2-savebar-note">No changes</span>}
						<span className="apw2-grow" />
						{resetButton}
						{updateButton}
					</div>
				</div>
				{resetDialog}
				{approvalStamp}
			</div>
		);
	}

	render() {
		if (!this.dataLoaded) { return (<div></div>); }

		var companyApprovalConfigurationList = [];
		var companyInvoiceConfigurationList = [];

		this.state.company.companyApprovalConfigurations
			//.filter(config => config.modelDefId !== 3)
			.map(function (companyApprovalConfiguration, index) {
				companyApprovalConfigurationList.push(<CompanyRoutingSetup key={index} company={this.state.company} companyApprovalConfiguration={companyApprovalConfiguration} changeHandler={this.changeHandler} />);
			}, this);

		this.state.company.companyInvoiceConfigurations
			//.filter(config => config.modelDefId !== 3)
			.map(function (companyInvoiceConfiguration, index) {
				companyInvoiceConfigurationList.push(<EmailReminderSetup key={index} companyInvoiceConfiguration={companyInvoiceConfiguration} changeHandler={this.changeHandler} />);
			}, this);

		const poFilterByDateInfo = {
			checkboxId: "chkPoFilterByDate",
			checkboxName: "poFilterByDate",
			checkboxValue: this.state.company.poFilterByDate,

			labelId: "lblPoFilterByDate",
			labelText: "PO Filter By Date"
		}
		const taxSetting = {
			labelId: 'lblTaxSetting',
			labelText: 'Tax Calculation based on',

			dropdownPlaceholder: "Tax Calculation based on",
			dropdownId: "ddlTaxSetting",
			dropdownValue: this.state.company.taxSetting
		}
		const allowOverrideTaxAmount = {
			checkboxId: "chkAllowOverrideTaxAmount",
			checkboxName: "allowOverrideTaxAmount",
			checkboxValue: this.state.company.allowOverrideTaxAmount,

			labelId: "lblAllowOverrideTaxAmount",
			labelText: "Allow Override Tax Amount"
		}
		const allowDiscrepantRoutingComments = {
			checkboxId: "chkAllowCommentsDiscrepantRouting",
			checkboxName: "allowCommentsDiscrepantRouting",
			checkboxValue: this.state.company.allowCommentsDiscrepantRouting,
			labelId: "lblAllowCommentsDiscrepantRouting",
			labelText: "Discrepant Routing Comments Required"
		}

		//const allowDiscrepantTaxes = {
		//	checkboxId: "chkAllowDiscrepantTaxes",
		//	checkboxName: "allowDiscrepantTaxes",
		//	checkboxValue: this.state.company.allowDiscrepantTaxes,

		//	labelId: "lblAllowDiscrepantTaxes",
		//	labelText: "Allow Discrepant Taxes"
		//}

		const companyRoutingFields = (
			<>
				<div className="form-group">
					<div className="labeldiv col-md-3">
						<label>Approval Stamp Settings:</label>
					</div>
					<div className="fielddiv col-md-3">
						<IconButton value="color" aria-label="Field Source" className="textAlignmentIcon" onClick={this.settings_clickHandler}>
							<SettingsIcon />
						</IconButton>
					</div>
				</div>
				<div className="form-group">
					<div className="labeldiv col-md-3">
						<label>PO Filter By Date:</label>
					</div>
					<div className="labeldiv col-md-3">
						<InputCheckbox checkboxInfo={poFilterByDateInfo} changeHandler={this.changeHandler} />
					</div>
				</div>
				<div className="form-group">
					<div className="labeldiv col-md-3" style={{ marginTop: 11 }}>
						<LabelText labelInfo={taxSetting} />
					</div>
					<div className="fielddiv col-md-3">
						<select id="ddlTaxSetting" name="taxSetting" className="drpChannel form-box form-control non-auth noDirty" value={this.state.company.taxSetting} onChange={this._ddlTaxSetting_changeHandler}>
							<option value="1">Tax Code</option>
							<option value="2">Invoice</option>
						</select>
					</div>
				</div>

				<div className="form-group">
					<div className="labeldiv col-md-3">
						<label>Allow Override Tax Amount</label>
					</div>
					<div className="labeldiv col-md-3">
						<InputCheckbox checkboxInfo={allowOverrideTaxAmount} changeHandler={this.changeHandler} />
					</div>
				</div>

				<div className="form-group">
					<div className="labeldiv col-md-3">
						<label>Discrepant Routing Comments Required</label>
					</div>
					<div className="labeldiv col-md-3">
						<InputCheckbox checkboxInfo={allowDiscrepantRoutingComments} changeHandler={this.changeHandler} />
					</div>
				</div>
			</>
		);
		const resetButton = (
			<button id="resetBtnMain" className="btn-grey" style={{ marginRight: 15 }} disabled={!this.state.isDirty} onClick={this.resetClickHandler}>
				Reset</button>
		);
		const updateButton = (
			<button id="saveBtnMain" className="btn-blue" disabled={!this.state.isDirty} onClick={this.updateClickHandler}>
				Update</button>
		);
		const resetDialog = (
			<Dialog open={this.state.openResetConfirmation} aria-labelledby="draggable-dialog-title">
				<DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
					Reset changes
				</DialogTitle>
				<DialogContent>
					<DialogContentText>
						This action will discard changes on this screen and refresh the page. Do you want to continue?
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={this.resetYesClickHandler} color="primary">
						Yes
					</Button>
					<Button autoFocus onClick={this.resetNoClickHandler} color="primary">
						No
					</Button>
				</DialogActions>
			</Dialog>
		);
		const approvalStamp = (
			<ApprovalStampConfiguration
				anchorEl={this.state.anchorEl}
				readOnly={this.state.readOnly}
				approvalStampConfiguration={this.state.company.approvalStampConfiguration}
				onChange={this.changeHandler}
				onClose={this.popover_closeHandler} />
		);

		if (isNewUi()) {
			return this.renderNewUi({ companyApprovalConfigurationList, companyInvoiceConfigurationList, companyRoutingFields, resetButton, updateButton, resetDialog, approvalStamp });
		}

		return (
			<div>
				<h1>Company Configuration</h1>
				<div className="todo-container marginBottom10">
					<div className="row">
						<div className="card ">
							<div className="header">
								<h4 className="title">General Info</h4>
								<span className="gadgeticons">
									<ul>
										<li onClick={this.collapseExpandHandler} id="GeneralInfoGadget">
											<i className="fa fa-minus" aria-hidden="true"></i>
										</li>
									</ul>
								</span>
							</div>
							<div className="content marginTop10 GeneralInfoGadget">
								<GeneralInfo company={this.state.company} changeHandler={this.changeHandler} />
							</div>
						</div>
					</div>
				</div>
				<div className="todo-container marginBottom10">
					<div className="row">
						<div className="card ">
							<div className="header">
								<h4 className="title">Company Identifier</h4>
								<span className="gadgeticons">
									<ul>
										<li onClick={this.collapseExpandHandler} id="CompanyIdentifierGadget">
											<i className="fa fa-minus" aria-hidden="true"></i>
										</li>
									</ul>
								</span>
							</div>
							<div className="content marginTop10 CompanyIdentifierGadget">
								<CompanyIdentifier company={this.state.company} setInProgress={this.props.inProgress} />
							</div>
						</div>
					</div>
				</div>
				<div className="todo-container marginBottom10">
					<div className="row">
						<div className="card ">
							<div className="header">
								<h4 className="title">Invoice Routing Setup</h4>
								<span className="gadgeticons">
									<ul>
										<li onClick={this.collapseExpandHandler} id="CompanyRoutingSetupGadget">
											<i className="fa fa-minus" aria-hidden="true"></i>
										</li>
									</ul>
								</span>
							</div>
							<div className="col-md-12 form-group CompanyRoutingSetupGadget" style={{ marginTop: 10 }} >
								{companyRoutingFields}
								{/*<div className="form-group">*/}
								{/*	<div className="labeldiv col-md-3">*/}
								{/*		<label>Allow Discrepant Taxes</label>*/}
								{/*	</div>*/}
								{/*	<div className="labeldiv col-md-3">*/}
								{/*		<InputCheckbox checkboxInfo={allowDiscrepantTaxes} changeHandler={this.changeHandler} />*/}
								{/*	</div>*/}
								{/*</div>*/}
								{companyApprovalConfigurationList}
							</div>
						</div>
					</div>
				</div>
				<div className="todo-container marginBottom10">
					<div className="row">
						<div className="card ">
							<div className="header">
								<h4 className="title">Invoice Setup</h4>
								<span className="gadgeticons">
									<ul>
										<li onClick={this.collapseExpandHandler} id="APInvoiceLandingSetupGadget">
											<i className="fa fa-minus" aria-hidden="true"></i>
										</li>
									</ul>
								</span>
							</div>
							<div className="content marginTop10 APInvoiceLandingSetupGadget">
								<APInvoiceLandingSetup company={this.state.company} changeHandler={this.changeHandler} />
							</div>
						</div>
					</div>
				</div>
				<div className="todo-container marginBottom10">
					<div className="row">
						<div className="card ">
							<div className="header">
								<h4 className="title">Email Reminder Setup</h4>
								<span className="gadgeticons">
									<ul>
										<li onClick={this.collapseExpandHandler} id="EmailReminderSetupGadget">
											<i className="fa fa-minus" aria-hidden="true"></i>
										</li>
									</ul>
								</span>
							</div>
							<div className="content marginTop10 EmailReminderSetupGadget">
								{companyInvoiceConfigurationList}
							</div>
						</div>
					</div>
					<div style={{ height: 50 }}>
						&nbsp;
					</div>
				</div>

				<div className="floatingButtons">
					{resetButton}
					{updateButton}
				</div>
				{resetDialog}
				{approvalStamp}

				{/*<CloudStorageConfig*/}
				{/*	company={this.state.company}*/}
				{/*	collapseExpandHandler={this.collapseExpandHandler }*/}

				{/*/>*/}
			</div>
		);
	}
}
